import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

export function PrivacyPolicy() {
  return (
    <div className="container mx-auto py-8 max-w-3xl">
      <Card>
        <CardHeader>
          <CardTitle className="text-center">Privacy Policy</CardTitle>
          <CardDescription className="text-center">
            Last Updated: {new Date().toLocaleDateString()}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">Introduction</h3>
            <p className="text-gray-700 leading-relaxed">
              Welcome to Secrely, a virtual assistant service that schedules meetings through phone calls. This Privacy Policy explains how we collect, use, and protect your personal information when you use our service.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">Information We Collect</h3>
            <p className="text-gray-700 leading-relaxed">We collect the following types of information:</p>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              <li><span className="font-medium">Account Information:</span> Email address and profile information from your Google account.</li>
              <li><span className="font-medium">Calendar Information:</span> Access to your Google Calendar to schedule and manage meetings.</li>
              <li><span className="font-medium">Voice Data:</span> Audio recordings of phone calls with our virtual assistant.</li>
              <li><span className="font-medium">Meeting Details:</span> Information about scheduled meetings, including date, time, participants, and purpose.</li>
              <li><span className="font-medium">Availability Information:</span> Your provided availability preferences for scheduling.</li>
            </ul>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">How We Use Your Information</h3>
            <p className="text-gray-700 leading-relaxed">We use your information to:</p>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              <li>Schedule and manage meetings on your behalf</li>
              <li>Improve our virtual assistant's ability to understand and process requests</li>
              <li>Provide customer support and respond to inquiries</li>
              <li>Send notifications about scheduled meetings</li>
              <li>Analyze usage patterns to improve our service</li>
            </ul>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">Data Sharing and Disclosure</h3>
            <p className="text-gray-700 leading-relaxed">
              We do not sell your personal information to third parties. We may share information with:
            </p>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              <li>Service providers who help operate our platform (e.g., cloud hosting, voice recognition)</li>
              <li>Google Calendar service to create and manage events</li>
              <li>Legal authorities when required by law</li>
            </ul>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">Data Security</h3>
            <p className="text-gray-700 leading-relaxed">
              We implement appropriate security measures to protect your information from unauthorized access or disclosure. These measures include encryption, secure storage, and access controls.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">Your Rights</h3>
            <p className="text-gray-700 leading-relaxed">You have the right to:</p>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Withdraw consent for processing your data</li>
              <li>Revoke Google Calendar access permissions</li>
            </ul>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">Contact Us</h3>
            <p className="text-gray-700 leading-relaxed">
              If you have questions or concerns about this Privacy Policy or our data practices, please contact us at: 
              <a href="mailto:anhminhnguyen1203@gmail.com" className="text-blue-600 hover:underline ml-1">anhminhnguyen1203@gmail.com</a>
            </p>
          </div>
          
          <div className="pt-6 text-center">
            <Button variant="outline" onClick={() => window.history.back()}>
              Return to App
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default PrivacyPolicy; 